export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxNl4c5ijTjQJElti5.87e1bc08.woff2";